import React from "react"

import classNames from "classnames/bind"
import styles from "../styles/Result.module.scss"
import { connect } from "react-redux"
import { withTranslation, Trans } from "react-i18next"
import "../i18n/i18n"

import { typeList } from "../constants/type"

export class ResultShareSection extends React.Component {
  // wechat : https://stackoverflow.com/questions/45005036/is-there-any-method-to-share-text-from-mobile-web-to-wechat-by-sharing-button
  // qq : https://stackoverflow.com/questions/16967666/how-to-create-a-tencent-weibo-qq-share-button/17445250
  // weibo: http://service.weibo.com/share/share.php?url=http://example.com&appkey=&title=Description&pic=&ralateUid=&language=zh_cn
  // weibo는 이미지도 가능

  getQueryStr = (shareMethod) => {
    const { type, lang } = this.props

    return `?sr=${typeList[type]["id"]}&r=${shareMethod}` + (lang !== "ko" ? `&lang=${lang}` : "")
  }

  // 유형에 맞는 결과 텍스트를 사용자 언어에 맞춰 가져오기
  getTypeText = (type) => {
    const { t } = this.props
    const typeIdx = typeList[type]["id"]

    const subTitle = t(`result.type${typeIdx}.subtitle`)
    const title = t(`result.type${typeIdx}.title`)
    const homeSubTitle = t("home.subTitle")

    return { subTitle, title, homeSubTitle }
  }

  shareByCopyingLink = () => {
    const { t } = this.props
    const qs = this.getQueryStr("fb")

    const ta = document.createElement("textarea")

    document.body.appendChild(ta)
    ta.value = `https://spti.snackpot.kr/${qs}`
    ta.select()
    document.execCommand("copy")
    document.body.removeChild(ta)

    alert(t("result.link_copied"))
  }

  shareByKakao = () => {
    const { type, lang } = this.props

    window.Kakao.Link.sendCustom({
      templateId: 33630,
      templateArgs: {
        typeId: typeList[type]["id"],
        typeTitle: typeList[type]["result"]["subtitle"] + (type === "esfp" ? " " : ", ") + typeList[type]["result"]["title"],
        typeImg: `https://s3.ap-northeast-2.amazonaws.com/spti.snackpot.kr/images/type/${typeList[type]["id"]}_1.png`,
        lang: lang,
      },
    })
  }

  shareByFacebook = () => {
    const { type } = this.props
    const { subTitle, title, homeSubTitle } = this.getTypeText(type)

    const qs = this.getQueryStr("fb")
    const msg = encodeURIComponent(`${subTitle} ${title}! \n${homeSubTitle}`)
    const url = encodeURIComponent("\nhttps://spti.snackpot.kr/" + qs)

    window.open(`https://facebook.com/sharer/sharer.php?quote=${msg}&u=${url}`)
  }

  shareByTwitter = () => {
    const { type } = this.props
    const { subTitle, title, homeSubTitle } = this.getTypeText(type)

    const qs = this.getQueryStr("tw")
    const msg = encodeURIComponent(`${subTitle} ${title}! \n${homeSubTitle}`)
    const url = encodeURIComponent("\nhttps://spti.snackpot.kr/" + qs)

    window.open(`https://twitter.com/intent/tweet?text=${msg}&url=${url}`)
  }

  shareByLINE = () => {
    const { type } = this.props
    const { subTitle, title, homeSubTitle } = this.getTypeText(type)

    const qs = this.getQueryStr("ln")
    const msg = encodeURIComponent(`${subTitle} ${title}! \n${homeSubTitle}`)
    const url = encodeURIComponent("\nhttps://spti.snackpot.kr/" + qs)

    window.open(`http://line.me/R/msg/text/?${msg}${url}`)
  }

  shareByWhatsApp = () => {
    const { type } = this.props
    const { subTitle, title, homeSubTitle } = this.getTypeText(type)

    const qs = this.getQueryStr("wa")
    const msg = encodeURIComponent(`${subTitle} ${title}! \n${homeSubTitle}`)
    const url = encodeURIComponent("\nhttps://spti.snackpot.kr/" + qs)

    // window.open(`https://wa.me/?text=${msg}${url}`)
    window.open(`whatsapp://send?text=${msg}${url}`)
  }

  shareByWeibo = () => {
    const { type } = this.props
    const { subTitle, title, homeSubTitle } = this.getTypeText(type)

    const qs = this.getQueryStr("we")
    const msg = encodeURIComponent(`${subTitle} ${title}! \n${homeSubTitle}`)
    const url = encodeURIComponent("\nhttps://spti.snackpot.kr/" + qs)
    const typeImg = encodeURIComponent(`https://s3.ap-northeast-2.amazonaws.com/spti.snackpot.kr/images/type/${typeList[type]["id"]}_1.png`)

    window.open(`http://service.weibo.com/share/share.php?url=${url}&appkey=&title=${msg}&pic=${typeImg}&ralateUid=&language=zh_cn`)
  }

  shareByWechat = () => {
    this.shareByCopyingLink()
    window.open("weixin://dl/chat")
  }

  shareByReddit = () => {
    const { type } = this.props
    const { subTitle, title, homeSubTitle } = this.getTypeText(type)

    const qs = this.getQueryStr("re")
    const msg = encodeURIComponent(`${subTitle} ${title}! \n${homeSubTitle}`)
    const url = encodeURIComponent("\nhttps://spti.snackpot.kr/" + qs)

    window.open(`http://www.reddit.com/submit?url=${msg}${url}&title=${homeSubTitle}`)
  }

  render() {
    const { sharedResult, refer, lang, t } = this.props

    return (
      <>
        <h3
          className={cn("share-title")}
          onClick={() => {
            window.open("weixin://dl/chat")
          }}
        >
          {sharedResult ? t(`result.share_my_title`) : t(`result.share_this_title`)}
        </h3>

        <div className={cn("share-btns")}>
          <div className={cn("share-btn")} onClick={this.shareByCopyingLink}>
            <img src="./images/share/share_url.svg" alt="URL sharing" />
          </div>
          <div id="kakaoShare" className={cn("share-btn")} onClick={this.shareByKakao}>
            <img src="./images/share/share_kakao.svg" alt="kakaotalk" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByTwitter}>
            <img src="./images/share/share_twitter.svg" alt="twitter" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByFacebook}>
            <img src="./images/share/share_facebook.svg" alt="facebook" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByLINE}>
            <img src="./images/share/share_line.svg" alt="LINE" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByWhatsApp}>
            <img src="./images/share/share_whatsapp.svg" alt="whatsapp" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByReddit}>
            <img src="./images/share/share_reddit.svg" alt="Reddit" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByWeibo}>
            <img src="./images/share/share_weibo.svg" alt="weibo" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByWechat}>
            <img src="./images/share/share_wechat.svg" alt="wechat" />
          </div>
          <div className={cn("share-btn")} onClick={this.shareByWhatsApp}>
            <img src="./images/share/share_qq.svg" alt="qq" />
          </div>
        </div>

        {/* '결과 공유하기' 버튼을 통해 들어온 경우, '테스트 다시하기'버튼을 '나도 테스트 해보기'로 대체 */}
        <div
          className={cn("re-btn", sharedResult && "sr-re-btn")}
          onClick={() => {
            window.location = `/?r=${refer}&lang=${lang}`
          }}
        >
          <span className={cn("btn-text", sharedResult && "sr-btn-text")}>{sharedResult ? t(`result.trytest`) : t(`result.testagain`)}</span>
        </div>

        <section className={cn("channel-list")}>
          <a className={cn("channel")} href="http://blog.snackpot.kr/222125152730" target="_blank" rel="noopener noreferrer">
            <img className={cn("logo")} src="./images/channel-naverblog.svg" alt="snackpot naver blog" />
            <div className={cn("desc")}>{t("result.morereview")}</div>
          </a>
          <a className={cn("channel")} href="https://www.instagram.com/snack_nakseo/" target="_blank" rel="noopener noreferrer">
            <img className={cn("logo")} src="./images/channel-instagram.png" alt="snackpot instagram" />
            <div className={cn("desc")}>{t("result.instagram")}</div>
          </a>
        </section>

        {/* <a onClick={this.shareByWhatsApp} data-action="share/whatsapp/share" target="_blank">
          Share to whatsapp
        </a> */}

        <a href="http://blog.snackpot.kr/222120626145" target="_blank" rel="noopener noreferrer">
          <div className={cn("faq")}>{t(`result.faq`)}</div>
        </a>

        <footer className={cn("footer")}>
          <a href="https://brand.snackpot.kr" target="_blank" rel="noopener noreferrer">
            <img src="./images/logo_full.svg" className={cn("logo")} alt="snackpot" />
          </a>
          <div className={cn("copyright")}>Copyright 2020 snackpot. all rights reserved</div>
          <div className={cn("copyright", "email")}>taero30@gmail.com</div>
        </footer>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  lang: state.general.lang,
  sharedResult: state.general.sharedResult,
  refer: state.general.refer,
})

const cn = classNames.bind(styles)

export default connect(mapStateToProps)(withTranslation()(ResultShareSection))
